import { render, staticRenderFns } from "./campaignTemplate.vue?vue&type=template&id=8dd8b424&scoped=true&"
import script from "./campaignTemplate.vue?vue&type=script&lang=js&"
export * from "./campaignTemplate.vue?vue&type=script&lang=js&"
import style0 from "./campaignTemplate.vue?vue&type=style&index=0&id=8dd8b424&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd8b424",
  null
  
)

export default component.exports